class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    // Guard: product pages run with load_minimog_runtime = false,
    // so MinimogTheme / MinimogLibs are undefined there. Without this
    // the accordion block throws and the sticky-bar block below
    // (which sets --mobile-sticky-bar-height) never runs.
    const hasRuntime =
      typeof MinimogTheme !== "undefined" &&
      MinimogTheme.config &&
      typeof MinimogLibs !== "undefined" &&
      MinimogLibs.Accordion;

    if (mobileAccordion) {
      if (hasRuntime) {
        const buildAccordion = () => {
          this.acc = new MinimogLibs.Accordion(mobileAccordion, {
            presetContentHeight: true,
            onload: true,
          });
        };

        if (MinimogTheme.config.mqlMobile) buildAccordion();
        document.addEventListener("matchMobile", buildAccordion);
      } else {
        // Fallback: no MinimogLibs available (e.g. product pages),
        // so run a minimal native accordion toggle instead.
        this.initFallbackAccordion(mobileAccordion);
      }
    }

    // Set mobile stickybar height — must run even without the runtime
    if (mobileStickyBar) {
      const setHeight = () => {
        document.documentElement.style.setProperty(
          "--mobile-sticky-bar-height",
          `${mobileStickyBar.offsetHeight}px`
        );
      };
      setHeight();
      document.addEventListener("matchMobile", setHeight);
      document.addEventListener("unmatchMobile", setHeight);
    }
  }

  initFallbackAccordion(container) {
    const items = container.querySelectorAll(".m-accordion--item");

    items.forEach((item) => {
      const button = item.querySelector(".m-accordion--item-button");
      const content = item.querySelector(".m-accordion--item-content");

      if (!button || !content) return;

      const openContent = () => {
        content.style.setProperty("--content-max-height", content.scrollHeight + "px");
        content.style.opacity = "1";
      };

      const closeContent = () => {
        content.style.setProperty("--content-max-height", "0px");
        content.style.opacity = "0";
      };

      // Respect items marked open by default (open_default setting)
      if (item.classList.contains("open")) {
        openContent();
      }

      button.addEventListener("click", () => {
        const isOpen = item.classList.contains("open");

        if (isOpen) {
          item.classList.remove("open");
          closeContent();
        } else {
          item.classList.add("open");
          openContent();
        }
      });
    });
  }
}
customElements.define("m-footer", MFooter);